/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_View_All_OrdersInputs */

const en_logistics_view_all_orders = /** @type {(inputs: Logistics_View_All_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View All Orders`)
};

const es_logistics_view_all_orders = /** @type {(inputs: Logistics_View_All_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los pedidos`)
};

/**
* | output |
* | --- |
* | "View All Orders" |
*
* @param {Logistics_View_All_OrdersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const logistics_view_all_orders = /** @type {((inputs?: Logistics_View_All_OrdersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_View_All_OrdersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_view_all_orders(inputs)
	return es_logistics_view_all_orders(inputs)
});